import React from 'react';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import PurchaseOrderProgressPresenter from './PurchaseOrderProgressPresenter';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: '0px 16px 16px 16px'
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all',
      '& b': {
        wordBreak: 'break-all'
      }
    }
  };
});

const AdjustedPurchaseOrderBubble: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          발주서
        </CustomizedTypography>
      </div>
      <PurchaseOrderProgressPresenter activeStep={2} />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
          >
            발주서 발행
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            수정 발주서가 파트너에게 발행 되었습니다.
            <br />
            파트너가 발주서 내용대로 발주를 진행할 수 없다고 판단하는 경우
            파트너가 <b>발주서 거부</b>를 할 수 있습니다.
          </CustomizedTypography>
        </div>
      </div>
    </Box>
  );
};

export default AdjustedPurchaseOrderBubble;
